export default function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      viewBox="0 0 30 30"
    >
      <path
        d="M29.752 14.219L15.333.232a.784.784 0 00-1.114 0L.232 14.652a.784.784 0 000 1.114l14.42 13.987a.922.922 0 00.557.248.672.672 0 00.557-.248l13.987-14.42a.922.922 0 00.248-.557.6.6 0 00-.249-.557zM15.209 28.143L1.841 15.209 14.775 1.841l13.368 12.934z"
        fill="#ffb898"
      />
      <path
        d="M14.219 9.773V13.6h-3.827a.753.753 0 00-.743.743.8.8 0 00.743.743h3.827v3.765a.753.753 0 00.743.743.8.8 0 00.743-.743v-3.766h3.765a.753.753 0 00.743-.743.7.7 0 00-.681-.743h-3.766V9.773a.753.753 0 00-.743-.743.86.86 0 00-.804.743z"
        fill="#fff"
      />
    </svg>
  );
}
